(function (root, factory) {
  var api = factory(root);

  root.PjMainGalleryPreview = api;

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var CONFIG_ID = 'pjMainGalleryPreviewConfig';
  var OVERLAY_CLASS = 'pj-gallery-preview';

  function slotStatus(slot) {
    if (!slot) return 'idle';
    if (slot.dataset && slot.dataset.uploadStatus) return slot.dataset.uploadStatus;
    if (slot.querySelector && slot.querySelector('.photo-upload-zone.has-photo')) return 'done';
    if (slot.querySelector && slot.querySelector('.photo-upload-zone.is-loading')) return 'loading';
    return 'idle';
  }

  function slotImageUrl(slot) {
    if (!slot || typeof slot.querySelector !== 'function') return '';
    var image = slot.querySelector('.photo-preview-img');
    if (!image) return '';
    return (
      image.currentSrc ||
      image.src ||
      (typeof image.getAttribute === 'function' ? image.getAttribute('src') : '') ||
      ''
    );
  }

  function visibleMultiSlots(doc) {
    if (!doc || typeof doc.querySelector !== 'function') return [];
    var uploader = doc.querySelector('.multi-image-uploader');
    if (!uploader || typeof uploader.querySelectorAll !== 'function') return [];

    return Array.prototype.map.call(
      Array.prototype.filter.call(
        uploader.querySelectorAll('.uploaderSection'),
        function (section) {
          return section.style.display !== 'none';
        }
      ),
      function (section) {
        return section.querySelector('.photo-upload-slot');
      }
    );
  }

  function uploaderSlots(doc) {
    var multi = visibleMultiSlots(doc).slice(0, 3);
    if (multi.length) return multi;

    var single =
      doc &&
      typeof doc.querySelector === 'function' &&
      doc.querySelector('.single-image-uploader .photo-upload-slot');
    return single ? [single] : [];
  }

  function uploadContext(doc) {
    var slots = uploaderSlots(doc);
    return {
      petCount: slots.length,
      sources: slots.map(function (slot) {
        return slotStatus(slot) === 'done' ? slotImageUrl(slot) : '';
      }),
    };
  }

  function galleryHosts(doc) {
    if (!doc || typeof doc.querySelectorAll !== 'function') return [];
    var hosts = [];

    // Pets sit on the slide the shopper currently has open, not on a forced
    // flat-lay that replaces the gallery. Before Splide marks a slide active,
    // the first slide is the one on screen.
    Array.prototype.forEach.call(
      doc.querySelectorAll('.product-gallery-main'),
      function (main) {
        var active =
          (main.querySelector &&
            (main.querySelector('.splide__slide.is-active') ||
              main.querySelector('.splide__slide'))) ||
          main;
        if (active) hosts.push(active);
      }
    );

    Array.prototype.forEach.call(
      doc.querySelectorAll('.gallery-stacked-images'),
      function (stacked) {
        var selected =
          stacked.querySelector &&
          (stacked.querySelector('.stacked-image-item.is-active .main-image') ||
            stacked.querySelector('.stacked-image-item .main-image'));
        if (selected) hosts.push(selected);
      }
    );
    return hosts;
  }

  function createGalleryPreviewController(doc, options) {
    var config = options || {};
    var processedBySource = {};
    var lastOverlay = null;
    var runId = 0;
    var initialized = false;

    function configElement() {
      return doc && doc.getElementById && doc.getElementById(CONFIG_ID);
    }

    function isEnabled() {
      var node = configElement();
      return Boolean(node && node.dataset && node.dataset.enabled === 'true');
    }

    function renderer() {
      return config.renderer || root.PjDesignLabRenderer;
    }

    function placement() {
      return config.placement || root.PjDesignLabPlacement;
    }

    function clear() {
      if (!doc || typeof doc.querySelectorAll !== 'function') return;
      Array.prototype.forEach.call(
        doc.querySelectorAll('.' + OVERLAY_CLASS),
        function (overlay) {
          if (typeof overlay.remove === 'function') overlay.remove();
          else if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        }
      );
    }

    async function processSource(sourceImage) {
      if (processedBySource[sourceImage]) return processedBySource[sourceImage];
      if (typeof config.processPet === 'function') {
        var configuredResult = await config.processPet(sourceImage, 'face_cutout');
        var configuredUrl =
          typeof configuredResult === 'string'
            ? configuredResult
            : configuredResult && configuredResult.imageUrl;
        if (!configuredUrl) throw new Error('Gallery cutout returned no image');
        processedBySource[sourceImage] = configuredUrl;
        return configuredUrl;
      }

      var node = configElement();
      var endpoint = node && node.dataset && node.dataset.cutoutUrl;
      var token = node && node.dataset && node.dataset.apiToken;
      if (!endpoint || !token || typeof root.fetch !== 'function') {
        throw new Error('Gallery preview processing is not configured');
      }

      var response = await root.fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'api-token': token,
        },
        body: JSON.stringify({
          imageUrl: sourceImage,
          mode: 'face_cutout',
        }),
      });
      if (!response.ok) throw new Error('Gallery portrait processing failed');

      var result = await response.json();
      if (!result || !result.imageUrl) throw new Error('Gallery cutout returned no image');
      processedBySource[sourceImage] = result.imageUrl;
      return result.imageUrl;
    }

    function preload(url) {
      if (typeof config.preload === 'function') return config.preload(url);
      if (!root.Image) return Promise.resolve(true);
      return new Promise(function (resolve) {
        var image = new root.Image();
        image.onload = function () {
          resolve(true);
        };
        image.onerror = function () {
          resolve(false);
        };
        image.src = url;
      });
    }

    function createOverlay(color, slots, processedImages) {
      var overlay = doc.createElement('div');
      overlay.className = OVERLAY_CLASS;
      overlay.setAttribute('aria-hidden', 'true');

      slots.forEach(function (slot, index) {
        if (!processedImages[index]) return;
        var pet = doc.createElement('img');
        pet.className = 'pj-gallery-preview__pet';
        pet.src = processedImages[index];
        pet.alt = '';
        pet.style.left = slot.x + '%';
        pet.style.top = slot.y + '%';
        pet.style.width = slot.width + '%';
        pet.style.transform =
          'translate(-50%, -50%) rotate(' + (Number(slot.rotation) || 0) + 'deg)';
        overlay.appendChild(pet);
      });
      overlay.dataset.color = color || '';
      return overlay;
    }

    function overlayOn(host) {
      return host && typeof host.querySelector === 'function'
        ? host.querySelector('.' + OVERLAY_CLASS)
        : null;
    }

    function slideAt(splide, index) {
      if (!splide || index == null) return null;
      var slides = splide.Components && splide.Components.Elements
        ? splide.Components.Elements.slides
        : null;
      if (slides && slides[index]) return slides[index];
      var at =
        splide.Components &&
        splide.Components.Slides &&
        typeof splide.Components.Slides.getAt === 'function'
          ? splide.Components.Slides.getAt(index)
          : null;
      return at && at.slide ? at.slide : null;
    }

    // Reuse the live overlay node so pet images do not unload (that flash is
    // the "blink"). `pruneOthers` is false while a fade is in flight so the
    // outgoing slide can keep its copy until the incoming one is selected.
    function attachOverlays(preferredHosts, pruneOthers) {
      if (!lastOverlay) return false;
      var hosts =
        preferredHosts && preferredHosts.length ? preferredHosts : galleryHosts(doc);
      if (!hosts.length) return false;

      Array.prototype.forEach.call(hosts, function (host) {
        if (!host || overlayOn(host)) return;
        var stray = null;
        // During a fade, copy onto the incoming slide and leave the outgoing
        // overlay in place. After the slide is selected, move the live node.
        if (pruneOthers !== false && doc && typeof doc.querySelectorAll === 'function') {
          Array.prototype.some.call(
            doc.querySelectorAll('.' + OVERLAY_CLASS),
            function (overlay) {
              if (hosts.indexOf(overlay.parentNode) !== -1) return false;
              stray = overlay;
              return true;
            }
          );
        }
        if (stray && stray.parentNode !== host) {
          host.appendChild(stray);
        } else {
          host.appendChild(
            createOverlay(
              lastOverlay.color,
              lastOverlay.slots,
              lastOverlay.processedImages
            )
          );
        }
      });

      if (pruneOthers !== false && doc && typeof doc.querySelectorAll === 'function') {
        Array.prototype.forEach.call(
          doc.querySelectorAll('.' + OVERLAY_CLASS),
          function (overlay) {
            if (hosts.indexOf(overlay.parentNode) === -1) {
              if (typeof overlay.remove === 'function') overlay.remove();
              else if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
            }
          }
        );
      }
      return true;
    }

    function scheduleAttachOverlays() {
      if (root.requestAnimationFrame) {
        root.requestAnimationFrame(function () {
          root.requestAnimationFrame(function () {
            attachOverlays();
          });
        });
        return;
      }
      attachOverlays();
    }

    function bindGallerySelection() {
      if (!doc || typeof doc.querySelectorAll !== 'function') return;
      Array.prototype.forEach.call(
        doc.querySelectorAll('splide-slider[data-slider-type="sync"]'),
        function (host) {
          var splide = host.slider;
          if (!splide || typeof splide.on !== 'function') return;
          if (host._pjGalleryPreviewSplide === splide) return;
          host._pjGalleryPreviewSplide = splide;
          if (host.dataset) host.dataset.pjGalleryPreviewWired = 'true';

          splide.on('move', function (newIndex, _prevIndex, destIndex) {
            var destSlide = slideAt(splide, destIndex != null ? destIndex : newIndex);
            if (destSlide) attachOverlays([destSlide], false);
          });
          splide.on('moved', function () {
            attachOverlays();
          });
          splide.on('active', function () {
            attachOverlays();
          });
        }
      );
    }

    async function render(processedImages, petCount, expectedRunId) {
      var renderApi = renderer();
      var placementApi = placement();
      var loadedPlacement =
        placementApi && placementApi.current && placementApi.current();
      if (
        !renderApi ||
        !placementApi ||
        !loadedPlacement ||
        !processedImages.some(Boolean)
      ) {
        clear();
        return false;
      }

      var selectedColor =
        typeof renderApi.resolveColor === 'function'
          ? renderApi.resolveColor(
              doc,
              typeof renderApi.selectedBackground === 'function'
                ? renderApi.selectedBackground(doc)
                : ''
            )
          : '';
      var resolved = placementApi.getSlots(loadedPlacement.catalog, {
        color: selectedColor,
        petCount: petCount,
      });
      if (!resolved || !resolved.ok) {
        lastOverlay = null;
        clear();
        return false;
      }

      var readyImages = processedImages.filter(Boolean);
      var loadResults = await Promise.all(readyImages.map(preload));
      if (expectedRunId !== runId) return false;

      var availableImages = processedImages.slice();
      var loadedPetIndex = 0;
      for (var index = 0; index < availableImages.length; index += 1) {
        if (!availableImages[index]) continue;
        if (!loadResults[loadedPetIndex]) availableImages[index] = '';
        loadedPetIndex += 1;
      }
      if (!availableImages.some(Boolean)) {
        lastOverlay = null;
        clear();
        return false;
      }

      lastOverlay = {
        color: resolved.colorKey,
        slots: resolved.slots,
        processedImages: availableImages,
      };
      bindGallerySelection();
      return attachOverlays();
    }

    async function refresh() {
      var thisRun = ++runId;
      if (!isEnabled()) {
        lastOverlay = null;
        clear();
        return false;
      }

      var context = uploadContext(doc);
      if (!context.petCount || !context.sources.some(Boolean)) {
        lastOverlay = null;
        clear();
        return false;
      }

      // Never leave the previous pet visible while a replacement or a newer
      // request is processing. The standard gallery remains underneath until
      // the current set of clean cutouts is ready.
      clear();

      // A slot still uploading must not show its raw image. Finished siblings
      // can render in their own template positions while this slot catches up.
      var processedImages = await Promise.all(
        context.sources.map(function (sourceImage) {
          if (!sourceImage) return Promise.resolve('');
          return processSource(sourceImage).catch(function () {
            return '';
          });
        })
      );
      if (thisRun !== runId) return false;
      return render(processedImages, context.petCount, thisRun);
    }

    function init() {
      if (!doc || typeof doc.addEventListener !== 'function') return;
      if (!initialized) {
        initialized = true;
        doc.addEventListener('pj-design-lab:uploader-state-change', refresh);
        doc.addEventListener('variant:change', refresh);
        doc.addEventListener('change', function (event) {
          var target = event && event.target;
          if (
            target &&
            typeof target.closest === 'function' &&
            target.closest(
              '.product-gallery-main, [data-switcher-thumbs], .gallery-stacked-images'
            )
          ) {
            return;
          }
          refresh();
        });
        doc.addEventListener('click', function (event) {
          var target = event && event.target;
          if (!target || typeof target.closest !== 'function') return;
          if (
            target.closest(
              '.product-gallery-main, [data-switcher-thumbs], .gallery-stacked-images'
            )
          ) {
            scheduleAttachOverlays();
          }
        });
      }
      bindGallerySelection();
      refresh();
    }

    return {
      clear: clear,
      init: init,
      refresh: refresh,
      uploadContext: function () {
        return uploadContext(doc);
      },
    };
  }

  var controller = root.document
    ? createGalleryPreviewController(root.document)
    : null;

  if (controller) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', controller.init, {
        once: true,
      });
    } else {
      controller.init();
    }
  }

  return {
    createGalleryPreviewController: createGalleryPreviewController,
    galleryHosts: galleryHosts,
    slotStatus: slotStatus,
    uploadContext: uploadContext,
    init: controller && controller.init,
    refresh: controller && controller.refresh,
  };
});
